import {
  FETCH_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILED,
  USER_SIGN_IN,
  USER_SIGN_IN_FAILED,
  USER_SIGN_OUT,
  CLEAR_LOGIN_ERROR,
  USER_OAUTH_NEEDS_PROFILE,
  REQUEST_OTP,
  REQUEST_OTP_SUCCESS,
  REQUEST_OTP_FAILED,
  UPDATE_USER_WALLET_HISTORY,
  SEND_RESET_EMAIL,
  SEND_RESET_EMAIL_FAILED
} from "../store/types";

import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import {
  ref,
  get,
  set,
  update,
  onValue,
  off,
  push,
  child
} from "firebase/database";
import { onAuthStateChanged, signInWithCredential, signInWithPopup, signOut, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithCustomToken } from "firebase/auth";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import base64 from 'react-native-base64';
import AccessKey from '../other/AccessKey';

export const fetchUser = () => (dispatch) => {
  const {
    auth,
    singleUserRef
  } = firebase;

  dispatch({
    type: FETCH_USER,
    payload: null
  });
  onAuthStateChanged(auth, user => {
    if (user) {
      let noProfileTimer = null;
      onValue(singleUserRef(user.uid), async snapshot => {
        if (snapshot.val()) {
          if (noProfileTimer) { clearTimeout(noProfileTimer); noProfileTimer = null; }
          let profile = snapshot.val();
          profile.uid = user.uid;
          dispatch({
            type: FETCH_USER_SUCCESS,
            payload: profile
          });
        } else {
          // Usuário autenticado no Firebase Auth, mas SEM perfil em users/{uid}.
          // Pode ser a janela curta do cadastro (perfil ainda sendo gravado), por
          // isso aguardamos um pouco. Se continuar ausente, é uma conta órfã
          // (Auth sem perfil) — sinalizamos falha para o login NÃO ficar travado
          // em spinner infinito e o usuário receber feedback.
          if (!noProfileTimer) {
            noProfileTimer = setTimeout(() => {
              if (auth.currentUser && auth.currentUser.uid === user.uid) {
                // Login social / SMS de conta nova: o perfil ainda não existe DE PROPÓSITO
                // porque o usuário está completando o cadastro (CPF/RG) na tela Register.
                // Não tratamos como órfã enquanto essa flag estiver ativa.
                const authState = store.getState().auth;
                if (authState && authState.oauthNeedsProfile) { return; }
                const langData = store.getState().languagedata.defaultLanguage;
                dispatch({
                  type: FETCH_USER_FAILED,
                  payload: {
                    code: langData.auth_error,
                    message: langData.not_registred || 'Perfil não encontrado.'
                  }
                });
              }
            }, 4000);
          }
        }
      });
    } else {
      dispatch({
        type: FETCH_USER_FAILED,
        payload: { code: store.getState().languagedata.defaultLanguage.auth_error, message: store.getState().languagedata.defaultLanguage.not_logged_in }
      });
    }
  });
};

export const validateReferer = async (referralId) => {
  const {
    config
  } = firebase;
  const response = await fetch(`https://${config.projectId}.web.app/validate_referrer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      referralId: referralId
    })
  })
  const json = await response.json();
  return json;
};

export const checkUserExists = async (data) => {
  const {
    config
  } = firebase;

  const settings = store.getState().settingsdata.settings;
  let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app` || `http://localhost:3000`
  let url = `${host}/check_user_exists`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey)
      },
      body: JSON.stringify({
        email: data.email,
        mobile: data.mobile,
        ...(data.document ? { document: data.document } : {}),
        ...(data.cpfCnpj ? { cpfCnpj: data.cpfCnpj } : {}),
        ...(data.excludeUid ? { excludeUid: data.excludeUid } : {}),
      })
    });
    if (!response.ok) {
      console.warn('[checkUserExists] server error', response.status);
      return { users: [], conflicts: {} };
    }
    const json = await response.json();
    return json;
  } catch (e) {
    console.warn('[checkUserExists] network error:', e.message);
    return { users: [], conflicts: {} };
  }
};

export const mainSignUp = async (regData) => {
  const { config } = firebase;
  const url = `https://${config.projectId}.web.app/user_signup`;

  const requestData = { regData: { ...regData, usertype: regData.usertype || "customer" } };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData)
    });

    const json = await response.json().catch(() => null);

    if (!response.ok) {
      return json || { ok: false, error: "server_error" };
    }

    return json;
  } catch (error) {
    return { ok: false, error: "network_error" };
  }
};

// authactions.js

export const updateProfileWithUniqueness = (profileData) => async (dispatch) => {
  const { auth, config } = firebase;
  const uid = auth.currentUser.uid;

  const settings = store.getState().settingsdata.settings;
  let host = window && window.location && settings.CompanyWebsite === window.location.origin
    ? window.location.origin
    : `https://${config.projectId}.web.app`;
  let url = `${host}/update_user_profile`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey)
      },
      body: JSON.stringify({ uid, profile: profileData })
    });
    const result = await response.json();
    if (result.error) {
      Alert.alert(store.getState().languagedata.defaultLanguage.alert, result.error);
      return { success: false, error: result.error };
    }
    // Opcional: disparar uma ação para atualizar o Redux com os novos dados
    // Você pode buscar o perfil atualizado ou simplesmente confiar que a função atualizou o banco
    // e o listener do onAuthStateChanged ou onValue vai atualizar.
    return { success: true };
  } catch (error) {
    Alert.alert(store.getState().languagedata.defaultLanguage.alert, "Network error");
    return { success: false, error };
  }
};

export const updateProfileWithUniquenessByUid = (uid, profileData) => async (dispatch) => {
  const { config } = firebase;

  const settings = store.getState().settingsdata.settings;
  let host = window && window.location && settings.CompanyWebsite === window.location.origin
    ? window.location.origin
    : `https://${config.projectId}.web.app`;
  let url = `${host}/update_user_profile`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey)
      },
      body: JSON.stringify({ uid, profile: profileData })
    });

    const result = await response.json().catch(() => ({}));

    if (!response.ok || result?.error) {
      return { success: false, error: result?.error || `http_${response.status}` };
    }

    return { success: true, data: result };
  } catch (error) {
    return { success: false, error: "network_error", detail: String(error?.message || error) };
  }
};

/*
export const mainSignUp = async (regData) => {
  const { config } = firebase;

  const url = `https://${config.projectId}.web.app/user_signup`;

  const requestData = {
    regData: {
      ...regData,

      //documento se ele estiver presente
      document: regData.hasOwnProperty("document")
        ? regData.document
        : null,

      rg: regData.rg || "",
      birthDate: regData.birthDate || "",
      gender: regData.gender || "",
      usertype: regData.usertype || "customer"
    }
  };

  //console.log("[mainSignUp] URL:", url);
  //console.log("[mainSignUp] Payload:", requestData);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData)
    });

    //console.log("[mainSignUp] HTTP status:", response.status);

    const text = await response.text();
    //console.log("[mainSignUp] Raw response text:", text);

    const json = JSON.parse(text);
    //console.log("[mainSignUp] Parsed response:", json);
    return json;

  } catch (error) {
    //console.log("[mainSignUp] Network error:", error);
    return {
      ok: false,
      step: "network",
      code: error?.code || "network_error",
      message: error?.message || String(error)
    };
  }
};
*/


const requestUpdateUserProfile = async (uid, profile) => {
  const { config } = firebase;
  const settings = store.getState().settingsdata?.settings;
  let host = typeof window !== 'undefined' && window.location && settings?.CompanyWebsite === window.location.origin
    ? window.location.origin
    : `https://${config.projectId}.web.app`;
  let url = `${host}/update_user_profile`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey)
      },
      body: JSON.stringify({ uid, profile })
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok || result?.error) {
      return { success: false, error: result?.error || `http_${response.status}` };
    }
    return { success: true };
  } catch (error) {
    return { success: false, error: 'network_error' };
  }
};

// Grava o perfil no RTDB e reserva CPF/CNPJ e RG (índices unique_cpf/unique_rg).
// allowDelete: no fluxo de email/senha, se a gravação falhar ou houver conflito de
// CPF/RG, a conta recém-criada no Auth é removida para não deixar órfã. No fluxo
// social (Google/Apple/SMS) a conta JÁ existe e é a identidade do usuário — não pode
// ser apagada; nesses casos passamos allowDelete:false e só removemos o nó users/{uid}
// se houver conflito para não deixar dados órfãos no banco.
const persistNewUserProfile = async (userCredential, regData, options = {}) => {
  const { allowDelete = true } = options;
  const { database } = firebase;
  const uid = userCredential.user.uid;

  const rawDoc = regData.document?.value || regData.cpfCnpj || regData.cpf || '';
  const cpfDigits = String(rawDoc).replace(/\D/g, '');
  const rgDigits = regData.rg ? String(regData.rg).replace(/\D/g, '') : '';
  const docObj = cpfDigits
    ? { type: cpfDigits.length === 14 ? 'CNPJ' : 'CPF', value: cpfDigits }
    : null;

  const refChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const generatedReferral = [...Array(5)].map(() => refChars[~~(Math.random() * refChars.length)]).join('');
  const settings = (store.getState().settingsdata && store.getState().settingsdata.settings) || {};
  const isDriver = regData.usertype === 'driver';

  const userProfile = {
    ...regData,
    uid: uid,
    createdAt: Date.now(),
    referralId: generatedReferral,
    signupViaReferral: regData.signupViaReferral || '',
    approved: isDriver ? (settings.driver_approval ? false : true) : true,
    ...(isDriver ? { queue: false, driverActiveStatus: false } : {}),
    profile_image: regData.profile_image || '',
    walletBalance: 0,
    pushToken: 'init',
    userPlatform: 'MOBILE'
  };

  // Remove campos sensíveis / temporários
  delete userProfile.password;
  delete userProfile.confirmpassword;
  delete userProfile.cpfCnpj;
  delete userProfile.cpf;

  // CPF/CNPJ (document) e RG são gravados pela Cloud Function após a reserva atômica (evita órfãos/duplicatas)
  delete userProfile.document;
  delete userProfile.rg;

  // Garante que o token de autenticação do novo usuário já esteja propagado antes de gravar o perfil.
  try { await userCredential.user.getIdToken(true); } catch (e) { /* ignore */ }

  // Salva no Realtime Database (sem document/rg ainda)
  try {
    await set(ref(database, `users/${uid}`), userProfile);
  } catch (writeErr) {
    console.error('❌ Falha ao gravar perfil no signup, removendo conta órfã:', writeErr);
    if (allowDelete) { try { await userCredential.user.delete(); } catch (e) { /* ignore */ } }
    return { error: true, code: 'profile_write_failed', message: 'Falha ao salvar o perfil. Tente novamente.' };
  }

  // Reserva atômica de CPF/CNPJ e RG (índices unique_cpf/unique_rg) via Cloud Function.
  if (cpfDigits || rgDigits) {
    const claim = await requestUpdateUserProfile(uid, {
      ...(docObj ? { document: docObj } : {}),
      ...(rgDigits ? { rg: rgDigits } : {})
    });
    const isCpfDuplicate = claim.error === 'cpf_already_exists' || claim.error === 'CPF já cadastrado';
    const isRgDuplicate = claim.error === 'rg_already_exists' || claim.error === 'RG já cadastrado';

    if (isCpfDuplicate || isRgDuplicate) {
      // Rollback: remove o nó para não deixar dados órfãos em users/{uid}.
      try { await set(ref(database, `users/${uid}`), null); } catch (e) { /* ignore */ }
      if (allowDelete) { try { await userCredential.user.delete(); } catch (e) { /* ignore */ } }
      const errorCode = isRgDuplicate ? 'rg_already_exists' : 'cpf_already_exists';
      const langData = (store.getState().languagedata && store.getState().languagedata.defaultLanguage) || {};
      return {
        error: true,
        code: errorCode,
        message: langData[errorCode] || (isRgDuplicate
          ? 'Este RG já está cadastrado em outra conta.'
          : 'Este CPF/CNPJ já está cadastrado em outra conta.')
      };
    }
    if (!claim.success) {
      try {
        await update(ref(database, `users/${uid}`), {
          ...(docObj ? { document: docObj } : {}),
          ...(rgDigits ? { rg: rgDigits } : {})
        });
      } catch (e) { /* ignore */ }
    }
  }

  return { uid: uid, success: true, message: 'Usuário criado com sucesso' };
};

// Completa o cadastro de um usuário que entrou por Google/Apple/SMS. A conta JÁ existe
// no Firebase Auth (criada pelo signInWithCredential), mas sem perfil em users/{uid}.
// Grava o perfil no uid existente SEM criar nova conta e SEM exigir senha.
export const completeOAuthProfile = async (regData) => {
  const { auth } = firebase;
  const user = auth.currentUser;
  if (!user) {
    return { error: true, code: 'no_auth_user', message: 'Sessão expirada. Entre novamente.' };
  }
  return await persistNewUserProfile({ user }, regData, { allowDelete: false });
};

// Usuário desistiu de completar o cadastro social/SMS. A conta no Auth foi criada pelo
// signInWithCredential mas está SEM perfil (órfã). Aqui APAGAMOS essa conta (não só
// signOut) e desanexamos o listener de perfil — senão uma nova tentativa reentra no
// mesmo uid sem perfil.
export const cancelOAuthProfile = () => (dispatch) => {
  const { auth, singleUserRef } = firebase;
  const user = auth.currentUser;
  if (user) {
    try { off(singleUserRef(user.uid)); } catch (e) { /* ignore */ }
    user.delete().catch(() => { try { signOut(auth); } catch (e) { /* ignore */ } });
  } else {
    try { signOut(auth); } catch (e) { /* ignore */ }
  }
  dispatch({
    type: USER_SIGN_OUT,
    payload: null
  });
};

export const updateProfileWithEmail = (profileData) => async (dispatch) => {
  const {
    config
  } = firebase;
  try{
    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/update_user_email`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey)
      },
      body: JSON.stringify(profileData)
    })
    const result = await response.json();
    if(result.error){ 
      return {success: false, error: result.error}
    }
  }catch(error){
    return {success: false, error: error}
  }
}


export const requestPhoneOtpDevice = (verificationId) => async (dispatch) => {
    dispatch({
      type: REQUEST_OTP_SUCCESS,
      payload: verificationId
    }); 
}

export const mobileSignIn = (verficationId, code, mobileInfo) => (dispatch) => {
  const {
    auth,
    mobileAuthCredential,
    database
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  signInWithCredential(auth, mobileAuthCredential(verficationId, code))
    .then(async (result) => {
      if (typeof document !== 'undefined') { return; }
      try {
        const uid = result.user.uid;
        const snap = await get(ref(database, `users/${uid}`));
        if (!snap.exists()) {
          dispatch({
            type: USER_OAUTH_NEEDS_PROFILE,
            payload: {
              uid,
              authMethod: 'mobile',
              mobile: (mobileInfo && mobileInfo.mobile) || '',
              countryCode: (mobileInfo && mobileInfo.countryCode) || ''
            }
          });
        }
      } catch (e) { /* fetchUser ainda cobre o caso de falha de leitura */ }
    }).catch(error => {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
};

export const saveAddresses = async (uid, location, name) => {
  const { singleUserRef } = firebase;
  onValue(child(singleUserRef(uid), "savedAddresses"), (savedAdd) => {
    if (savedAdd.val()) {
      let addresses = savedAdd.val();
      let didNotMatch = true;
      for (let key in addresses) {
        let entry = addresses[key];
        if (entry.name == name ) {
          didNotMatch = false;
          update(child(singleUserRef(uid),"savedAddresses/" + key),{
            description: location.add,
            lat: location.lat,
            lng: location.lng,
            count: 1,
            name: name
          });
          break;
        }
      }
      if (didNotMatch) {
        push(child(singleUserRef(uid),"savedAddresses"),{
          description: location.add,
          lat: location.lat,
          lng: location.lng,
          count: 1,
          name: name
        });
      }
    } else {
      push(child(singleUserRef(uid),"savedAddresses"),{
        description: location.add,
        lat: location.lat,
        lng: location.lng,
        count: 1,
        name: name
      });
    }
  }, {onlyOnce: true});
};

export const googleLogin = (idToken, accessToken, oauthInfo) => (dispatch) => {

  const {
    auth,
    googleCredential,
    database
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });

  const credential = googleCredential(idToken, accessToken);
  signInWithCredential(auth, credential)
    .then(async (result) => {
      if (typeof document !== 'undefined') { return; }
      try {
        const uid = result.user.uid;
        const snap = await get(ref(database, `users/${uid}`));
        if (!snap.exists()) {
          dispatch({
            type: USER_OAUTH_NEEDS_PROFILE,
            payload: {
              uid,
              email: result.user.email || (oauthInfo && oauthInfo.email) || '',
              firstName: (oauthInfo && oauthInfo.firstName) || '',
              lastName: (oauthInfo && oauthInfo.lastName) || ''
            }
          });
        }
      } catch (e) { /* fetchUser ainda cobre o caso de falha de leitura */ }
    })
    .catch(error => {
      console.log(error);
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
}

export const appleSignIn = (credentialData, oauthInfo) => (dispatch) => {

  const {
    auth,
    appleProvider,
    database
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  if (credentialData) {
    const credential = appleProvider.credential(credentialData);
    signInWithCredential(auth, credential)
      .then(async (result) => {
        if (typeof document !== 'undefined') { return; }
        try {
          const uid = result.user.uid;
          const snap = await get(ref(database, `users/${uid}`));
          if (!snap.exists()) {
            dispatch({
              type: USER_OAUTH_NEEDS_PROFILE,
              payload: {
                uid,
                email: result.user.email || (oauthInfo && oauthInfo.email) || '',
                firstName: (oauthInfo && oauthInfo.firstName) || '',
                lastName: (oauthInfo && oauthInfo.lastName) || ''
              }
            });
          }
        } catch (e) { /* fetchUser ainda cobre o caso de falha de leitura */ }
      })
      .catch((error) => {
        dispatch({
          type: USER_SIGN_IN_FAILED,
          payload: error
        });
      });
  } else {
    signInWithPopup(auth, appleProvider).then(function (result) {
      signInWithCredential(auth, result.credential)
        .then((user) => {
        //OnAuthStateChange takes care of Navigation
        })
        .catch(error => {
          dispatch({
            type: USER_SIGN_IN_FAILED,
            payload: error
          });
        }
        );
    }).catch(function (error) {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
  }
};

export const signOff = () => (dispatch) => {

  const {
    auth,
    singleUserRef,
    walletHistoryRef,
    userNotificationsRef
  } = firebase;

  const uid = auth.currentUser.uid;

  off(singleUserRef(uid));
  off(walletHistoryRef(uid));
  off(userNotificationsRef(uid));

  onValue(singleUserRef(uid), snapshot => {
      if(snapshot.val()){
        const profile = snapshot.val();
        if (profile && profile.usertype === 'driver') {
          update(singleUserRef(uid), {driverActiveStatus:false});
        }
        setTimeout(()=>{
          signOut(auth)
          .then(() => {
            dispatch({
              type: USER_SIGN_OUT,
              payload: null
            });
          })
          .catch(error => {
      
          });
        },2000)
      }
  },{onlyOnce: true});
};

export const updateProfile = (updateData) => async (dispatch) => {
  try {
    const {
      auth,
      singleUserRef,
      driverDocsRef,
      driverDocsRefBack,
      verifyIdImageRef,
      addressProofRef,
      criminalRecordRef
    } = firebase;

    const uid = auth.currentUser.uid;

    if (updateData.licenseImage) {
      await uploadBytesResumable(driverDocsRef(uid), updateData.licenseImage);
      updateData.licenseImage = await getDownloadURL(driverDocsRef(uid));
    }

    if (updateData.licenseImageBack) {
      await uploadBytesResumable(driverDocsRefBack(uid), updateData.licenseImageBack);
      updateData.licenseImageBack = await getDownloadURL(driverDocsRefBack(uid));
    }

    if (updateData.verifyIdImage) {
      await uploadBytesResumable(verifyIdImageRef(uid), updateData.verifyIdImage);
      updateData.verifyIdImage = await getDownloadURL(verifyIdImageRef(uid));
    }

    if (updateData.addressProof) {
      await uploadBytesResumable(addressProofRef(uid), updateData.addressProof);
      updateData.addressProof = await getDownloadURL(addressProofRef(uid));
    }

    if (updateData.criminalRecord) {
      await uploadBytesResumable(criminalRecordRef(uid), updateData.criminalRecord);
      updateData.criminalRecord = await getDownloadURL(criminalRecordRef(uid));
    }

    await update(singleUserRef(uid), updateData);

    return { success: true };

  } catch (error) {
    console.log("UPLOAD ERROR:", error);
    return { success: false, error };
  }
};


export const updateProfileImage = (imageBlob) => {

  const {
    auth,
    singleUserRef,
    profileImageRef,
  } = firebase;

  const uid = auth.currentUser.uid;

  uploadBytesResumable( profileImageRef(uid), imageBlob).then(() => {
    imageBlob.close()
    return getDownloadURL(profileImageRef(uid))
  }).then((url) => {
    update(singleUserRef(uid), {
      profile_image: url
    });
  })
};

export const updateWebProfileImage = async (imageBlob) => {

  const {
    auth,
    singleUserRef,
    profileImageRef
  } = firebase;

  const uid = auth.currentUser.uid;

  await uploadBytesResumable(profileImageRef(uid), imageBlob);
  let image = await getDownloadURL(profileImageRef(uid));
  update(singleUserRef(uid), {profile_image: image});

};
export const updateCustomerProfileImage = async (imageBlob, id) => {

  const {
    singleUserRef,
    profileImageRef
  } = firebase;

  const uid = id

  await uploadBytesResumable(profileImageRef(uid), imageBlob);
  let image = await getDownloadURL(profileImageRef(uid));
  update(singleUserRef(uid), {profile_image: image});

};

export const updatePushToken = (token, platform)  => {

  const {
    auth,
    singleUserRef,
  } = firebase;

  const uid = auth.currentUser.uid;

  update(singleUserRef(uid), {
    pushToken: token,
    userPlatform: platform
  });
};

export const clearLoginError = () => (dispatch) => {
  dispatch({
    type: CLEAR_LOGIN_ERROR,
    payload: null
  });
};

export const fetchWalletHistory = () => (dispatch) => {
  const {
    auth,
    walletHistoryRef
  } = firebase;

  const uid = auth.currentUser.uid;

  onValue(walletHistoryRef(uid) , snapshot => {
    const data = snapshot.val(); 
    if(data){
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: arr.reverse()
      });
    }
  });
};
export const fetchUserWalletHistory = (userId) => (dispatch) => {
  const {
    auth,
    walletHistoryRef
  } = firebase;

  const uid = userId;

  onValue(walletHistoryRef(uid) , snapshot => {
    const data = snapshot.val(); 
    if(data){
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: arr.reverse()
      });
    }else{
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload:[]
      });
    }
  });
};

export const sendResetMail = (email) => async (dispatch) => {
  const {
    authRef
  } = firebase;

  dispatch({
    type: SEND_RESET_EMAIL,
    payload: email
  });
  sendPasswordResetEmail(authRef(), email).then(function() {
    console.log('Email send successfuly');
  }).catch(function (error) {
      dispatch({
        type: SEND_RESET_EMAIL_FAILED,
        payload: {code: store.getState().languagedata.defaultLanguage.auth_error, message: store.getState().languagedata.defaultLanguage.not_registred }
      });
  });
};

export const verifyEmailPassword = (email, pass) => async (dispatch) => {
  const {
    authRef
  } = firebase;

  signInWithEmailAndPassword(authRef(), email, pass)
    .then((user) => {
      //OnAuthStateChange takes care of Navigation
    })
    .catch((error) => {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
}

export const requestMobileOtp = (mobile) => async (dispatch) => {
  const {
    config
  } = firebase;
  dispatch({
    type: REQUEST_OTP,
    payload: true
  }); 

  const settings = store.getState().settingsdata.settings;
  let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
  let url = `${host}/request_mobile_otp`;
  try{
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mobile: mobile })
    });
    const result = await response.json();
    if(result.success){
      dispatch({
        type: REQUEST_OTP_SUCCESS,
        payload: true
      });
    }else{
      dispatch({
        type: REQUEST_OTP_FAILED,
        payload: result.error
      });
    }
  }catch(error){
    console.log(error);
  }
}

export const verifyMobileOtp = (mobile, otp, mobileInfo) => async (dispatch) => {
  const {
    auth,
    config,
    database
  } = firebase;
  const body = {
    mobile: mobile,
    otp: otp
  };
  try{
    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/verify_mobile_otp`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    const result = await response.json();
    if(result.token){
      signInWithCustomToken(auth,result.token)
        .then(async (cred) => {
          if (typeof document !== 'undefined') { return; }
          try {
            const uid = cred.user.uid;
            const snap = await get(ref(database, `users/${uid}`));
            if (!snap.exists()) {
              dispatch({
                type: USER_OAUTH_NEEDS_PROFILE,
                payload: {
                  uid,
                  authMethod: 'mobile',
                  mobile: (mobileInfo && mobileInfo.mobile) || '',
                  countryCode: (mobileInfo && mobileInfo.countryCode) || ''
                }
              });
            }
          } catch (e) { /* fetchUser ainda cobre o caso de falha de leitura */ }
        })
        .catch((error) => {
          dispatch({
            type: USER_SIGN_IN_FAILED,
            payload: error
          });
        });
    }else{
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: result.error
      });
    }
  }catch(error){
    console.log(error);
    dispatch({
      type: USER_SIGN_IN_FAILED,
      payload: error
    });
  }
}

export const updateAuthMobile = async ( mobile, otp) => {
  const {
    auth,
    config
  } = firebase;

  const uid = auth.currentUser.uid;
  const body = {
    uid: uid,
    mobile: mobile,
    otp: otp
  };

  const settings = store.getState().settingsdata.settings;
  let host = window && window.location && settings.CompanyWebsite === window.location.origin ? window.location.origin : `https://${config.projectId}.web.app`
  let url = `${host}/update_auth_mobile`;
  try{
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    const result = await response.json();
    if(result.success){
      return {success: true}
    }else{
      return {success: false, error: result.error}
    }
  }catch(error){
    return {success: false, error: error}
  }
}
